// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  basePath: 'https://verse.truno.com/gateway/',
  backOfficeBasePath: 'https://verse.truno.com/api/',
  version: '0.0.0',
  buildTimestamp: 1563383283,
  shortCommitId: '42939d7',
  commitId: '42939d778fad7c261bcba0174833b8cdfc3a9528',
  commitTime: 1563338111
};
